module.exports = __webpack_public_path__ + "static/media/05n.afd241b4.svg";